import React from 'react'


import Header from './templates/Header';
import Footer from './templates/Footer';
import SEO from './templates/SEO';

function Privacy() {
  return (
    <div>

<SEO title="Privacy and Policy Page"/>

<Header/>


<div class="aboutarea__5 sp_bottom_100">
            <div class="container">
                <div class="row">

                <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 mx-auto">


<div class="blog__details__content__wraper">

    <div class="course__list__wraper aos-init aos-animate" data-aos="fade-up">

    <div class="blog__details__heading__2">
            <h3>Privacy Policy</h3>
            <h6>Effective Date : 01-04-2025</h6>
        </div>
    

<div class="experence__description">
                    <p class="description__1">At <strong className='text-white'>Trading Whales,</strong> your privacy is a top priority. This Privacy Policy explains how we collect, use, and protect your personal information when you visit our website or enroll in our courses.
                    </p>
                    <h5>1. Information We Collect</h5>
                    <p class="description__2">We may collect the following types of information:  <br />
                    <strong>Personal Information: </strong> Name, email address, phone number, age, and payment details. <br />
                    <strong>Usage Information: </strong>Browser type, IP address, pages visited, and access time.   <br />
                    <strong>Course Interaction: </strong>Progress, feedback, test scores, and session participation. <br />


                    </p>
              

                    <h5>2. How We Use Your Information</h5>
                    <p class="description__3"> We use your information for the following purposes: <br />
                    To provide access to courses and services. <br />
                    To process payments securely. <br />
                    To improve user experience and website performance. <br />
                    To send important updates, newsletters, and offers (you may opt out anytime). <br />
                    To ensure compliance with our Terms and applicable laws. <br />

                       </p>
                    
                    <h5>3. Sharing of Information</h5>
                    <p className='description_3'>We do <strong>not</strong> sell or rent your personal data to third parties. However, we may share information with: <br />
                    
                    <strong>Trusted third-party providers </strong>  (e.g., payment gateways, webinar platforms). <br />
                    <strong>Legal authorities </strong>if required to comply with legal obligations. <br />
                    
                    </p>
                    
                    <h5>4. Data Security</h5>
                    <p className='description_3'>We implement industry-standard security measures, including encryption, firewalls, and secure server access to protect your data. However, no method of transmission is 100% secure, and we cannot guarantee absolute security.
                    </p>
                    
                    <h5>5. Cookies and Tracking</h5>
                    <p className='description_3'>We use cookies to: <br />
                    Improve website functionality. <br />
                    Analyze user behavior and traffic. <br />
                    Store preferences for a better user experience. <br />
                    You can disable cookies through your browser settings, though it may affect your site experience.

                    </p>
                    
                    <h5>6. Third-Party Links</h5>
                    <p className='description_3'>Our site may contain links to third-party platforms (e.g., Zoom, Razorpay, YouTube). We are not responsible for their privacy practices. Please review their policies separately.
                    </p>
                    
                    <h5>7. Policy Updates</h5>
                    <p className='description_3'>We may update this Privacy Policy from time to time. Changes will be reflected on this page with an updated "Effective Date." Continued use of our services implies acceptance of the updated policy.
                    </p>
                    
                  
                    <h5>8. Contact Us</h5>
                    <p className='description_3'>If you have any questions regarding these Terms, please contact us at:
                    </p>
                    <a href="mailto:info@tradingwhales.in">info@tradingwhales.in</a> <br />
                    <a href="tel:+91 9491065567">+91 94910 65567</a>



                     </div>

    </div>



</div>
</div>


 </div>
 </div>         
       </div>



<Footer/>
      


    </div>
  )
}

export default Privacy
